<template>
 <section class="newTable" >
  <table class="table datatable table-striped area-list-datatable" id="PrecisionMarketingDataTable" >
    <thead>
      <tr>
        <th width="120">
          <div class="checkbox checkbox-inline mr-0">
            <input 
            @click="checkAllClick = true"
            type="checkbox" 
            name="check-all" 
            id="check-all" 
            value="1" 
            v-model="checkAll">
            <label for="check-all"></label>
          </div>
          <span>#</span>
        </th>
        <th
        width="*"
        :class="'sorting ' + (order.index==1 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting(1)"
        >姓名</th>
        <th
        width="*"
        :class="'sorting ' + (order.index==2 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting(2)"
        >手機</th>
        <th
        width="*"
        :class="'sorting ' + (order.index==3 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting(3)"
        >生日</th>
        <th
        width="*"
        :class="'sorting ' + (order.index==4 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting(4)"
        >疾病醫療日額</th>
        <th
        width="*"
        :class="'sorting ' + (order.index==5 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting(5)"
        >疾病醫療日額上限</th>
        <th
        width="*"
        :class="'sorting ' + (order.index==6 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting(6)"
        >壽險保額通算</th>
        <th
        width="100"
        :class="'sorting ' + (order.index==7 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting(7)"
        >公司往來</th>
        <th
        width="80"
        :class="'sorting ' + (order.index==8 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting(8)"
        >備註</th>
        <th
        width="148"
        :class="'sorting ' + (order.index==9 ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
        @click="columnSorting(9)"
        >排訪</th>
      </tr>
    </thead>
    <tbody @scroll="scrollmethod" class="block-height" :style="{height: height + 'px'}">
        <tr v-for="(d, did) in tableData" :key="`PrecisionMarketingDataTable-table-td-${did}`">
          <td width="120">
            <div style="min-height: 30px;">
              <div class="mr-0 checkbox checkbox-inline">
                <input
                @click="checkAllClick = false"
                type="checkbox"
                name="`td-item[]`"
                :id="`PrecisionMarketingDataTable-check-${did}`"
                :value="d.id"
                v-model="selection"
                :disabled="d.id === ''"
                @change="$emit('update', selection)">
                <label :for="`PrecisionMarketingDataTable-check-${did}`"></label>
              </div>
              
              <span>
              <span class="no">{{did + 1}}</span>
              <span class="info text-center">
                <level :lv="Number(d.vip_level)" />
                <avatar :gender="Number(d.sex)" :size="20" />
              </span>
              </span>
            </div>
          </td>
          <td width="*"><a class="text-green text-underline pointer-cursor" @click="$emit('jump-to-customer', d.index)">{{d.name}}</a></td>
          <td width="*">{{d.mobile}}</td>
          <td width="*">
            <span>
                <div class="date">{{d.birthday}}</div>
                <div class="age">
                  <!-- <b>{{ d[col.name] | ageCounter }}</b>歲 -->
                  <b>{{ d.age? d.age : '— —' }}</b>歲
                </div>
              </span>
          </td>
          <td width="*">{{d.disease_medical_day_pay}}</td>
          <td width="*">{{d.disease_medical_day_limit}}</td>
          <td width="*">{{d.life_insurance_coverage}}</td>
          <td width="100">
            <span>
              <div class="list inline">
                <span class="tag-box" :class="d.idmark && d.idmark.indexOf('1') > -1 ? 'active': ''">
                  要
                </span>
                <span class="tag-box" :class="d.idmark && d.idmark.indexOf('2') > -1 ? 'active': ''">
                  被
                </span>
                <span class="tag-box" :class="d.idmark && d.idmark.indexOf('3') > -1 ? 'active': ''">
                  意
                </span>
                <span class="tag-box" :class="d.idmark && d.idmark.indexOf('5') > -1 ? 'active': ''">
                  團
                </span>
                <span class="tag-box" :class="d.idmark && d.idmark.indexOf('6') > -1 ? 'active': ''">
                  借
                </span>
              </div>
            </span>
          </td>
          <td width="80">
            <a class="text-green text-underline pointer-cursor" @click="$emit('comment-modal', '5月12日拜訪已經提過建議書<br />5月20日再次聯絡客戶')">詳情</a>
          </td>
          <td :width="iPadWidth">
            <button 
            v-if="!d.visit.id"
            class="btn btn-primary" 
            @click="$emit('scheduled-access', did)"
            v-html="'<span style=\'font-size:1.25rem\'>預約<span>'"></button>
            <button 
            v-else
            class="btn btn-primary" style="font-size:0.8rem;" 
            @click="$emit('scheduled-access', did)">{{ d.visit.str_date | dateFormat }}<br>{{ d.visit.str_time }}</button>
          </td>
        </tr>
        <tr v-if="tableData.length == 0">
          <td colspan="8" class="text-center pt-3 pb-5">
            <h3>
              無客戶名單資料
            </h3>
          </td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
        </tr>
    </tbody>
  </table>
  </section>
</template>

<script>
import Level from '@/components/Level'
import Avatar from '@/components/Avatar'
import { commonMixin } from '@/mixins/common'
import { setTimeout } from 'timers';

const is_iPad = navigator.userAgent.match(/iPad/i) != null // 確認裝置是否為 iPad
let idmarkWidth = 148
if(is_iPad){
  idmarkWidth = 131
}

export default {
    name: "PrecisionMarketingDataTable",
    mixins: [commonMixin],
    components: {Level, Avatar},
    props: {
        tableData: {
            type: Array,
            default: () => {
                return []
            }
        },
        height: {
            type: Number,
            default: () => {
                return 350
            }
        },
    },
    data() {
        return {
            order: {
                index: 0,
                asc: true
            },
            checkAll: 0,
            selection: [],
            currentWidth: 0,
            is_iPad: is_iPad,
            iPadWidth: idmarkWidth,
            checkAllClick: false,
        }
    },
    watch: {
      tableData: function () {
        this.checkAll = false
        this.registerHanlink(); // for 難字更新
      },
      checkAll: function(val){
        if(val && this.checkAllClick) {
          this.selection = []
          this.tableData.forEach(data => {
            if(data.id !== ''){
              this.selection.push(data.id)
            }
          });
          this.$emit('update', this.selection)
        } else if(this.checkAllClick){
          if(!this.addPageStatus){
            this.selection = []
          }
          this.$emit('update', this.selection)
        }
      },
      
    },
    methods: {
      scrollmethod(e){
        // this.nowTime = +new Date()
        // if(this.nowTime > this.lastTime + 150){
        //   this.lastTime = this.nowTime
        //   if (!this.scrollDataLoading && e.target.scrollTop > (e.target.scrollHeight - 700)) {
        //     this.options.scrollLoadingAPI()
        //   }
        // }
      },
      columnSorting (i) {
          if(this.order.index===i) {
              this.order.asc = !this.order.asc
          }
          else {
              this.order.index = i
              this.order.asc = true
          }
        }
    },
    mounted () {
        this.currentWidth = this.$el.clientWidth * (this.$el.clientWidth < 1250 ? 0.95 : 1)
        if(!is_iPad) {
          this.iPadWidth = '131'
        }else{
          this.iPadWidth = '148'
        }
    }
}
</script>

<style lang="scss" scoped>
.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;

  td {
    word-break: break-all;
  }
  
  &.sorting,
  &.sorting_desc {
    position: relative;
    padding-right: 25px !important;
    
    &:before,
    &:after {
      content: '';
      position: absolute;
      width: 0px;
      height: 0px;
      display: block;
      top: 0;
      bottom: 0;
      right: 6px;
      margin: auto;
    }

    &:after {
      top: 18px;
      border-top: 6px solid transparentize(#027A39, .5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }

    &:before {
      top: -13px;
      border-bottom: 6px solid transparentize(#027A39, .5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid transparent;
    }
  }

  &.sorting_asc:before {
    border-bottom: 6px solid transparentize(white, .5);
  }

  &.sorting_desc:after {
    border-top: 6px solid transparentize(white, .5);
  }

  &.no-sort:before,
  &.no-sort:after {
    display: none;
  }
}


.newTable tbody.block-height {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px; 
    border: 0;
    box-shadow: none;
  }
  
  &::-webkit-scrollbar-track
  {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb
  {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}
</style>
